import React, { useState, useEffect } from 'react';
import { Row, Col, Card, CardHeader, CardBody, Table } from 'reactstrap';
import { Link } from 'react-router-dom';
import { useAlert } from 'hooks';
import AlertModal from 'components/AlertModal';
import {
  getAllConsultoriosCokiba,
  getAllSolicitudesConsultorios,
  getAllSolicitudesConsultoriosBaja,
  getAllSolicitudesConsultoriosRenovacion,
  getAllSolicitudesConsultoriosUpdateEdilicia,
  getAllSolicitudesConsultoriosUpdateDirector,
  getAllSolicitudesConsultoriosUpdatePropietario,
} from '../../features/consultorios/consultoriosAPI';
import {
  getAllSolicitudesStaffMultiple,
  getAllSolicitudesStaff,
  getAllSolicitudesStaffBaja,
} from '../../features/staff/staffAPI';
import {
  Consultorio,
  ConsultorioBaja,
  ConsultorioRenovacion,
  ConsultorioCokiba,
  ConsultorioUpdateEdilicia,
  ConsultorioUpdateDirector,
  ConsultorioUpdatePropietario,
} from 'types/Consultorio';
import {
  StaffMultipleRequest,
  StaffConsultorioRequest,
  StaffBajaConsultorioRequest,
} from 'types/Staff';

export default function ListConsultorios() {
  const [data, setData] = useState<ConsultorioCokiba[]>([]);
  const [solicitudes, setSolicitudes] = useState<Consultorio[]>([]);
  const [solicitudesBaja, setSolicitudesBaja] = useState<ConsultorioBaja[]>([]);
  const [solicitudesRenovacion, setSolicitudesRenovacion] = useState<ConsultorioRenovacion[]>([]);
  const [solicitudesUpdateEdilicia, setSolicitudesUpdateEdilicia] = useState<ConsultorioUpdateEdilicia[]>([]);
  const [solicitudesUpdateDirector, setSolicitudesUpdateDirector] = useState<ConsultorioUpdateDirector[]>([]);
  const [solicitudesUpdatePropietario, setSolicitudesUpdatePropietario] = useState<ConsultorioUpdatePropietario[]>([]);
  const [solicitudesStaffMultiple, setSolicitudesStaffMultiple] = useState<StaffMultipleRequest[]>([]);
  const [solicitudesStaff, setSolicitudesStaff] = useState<StaffConsultorioRequest[]>([]);
  const [solicitudesStaffBaja, setSolicitudesStaffBaja] = useState<StaffBajaConsultorioRequest[]>([]);

  const [showAlert, message, alert] = useAlert(false, '');

  useEffect(() => {
    getAllConsultoriosCokiba()
      .then(response => {
        setData(response);
      })
      .catch(err => {
        alert(true, err.getMessage() || 'No se puedieron obtener los consultorios del matriculado');
      });

    getAllSolicitudesConsultorios()
      .then(response => {
        setSolicitudes(response);
      })
      .catch(err => {
        alert(true, err.getMessage() || 'No se puedieron obtener las solicitudes de consultorio del matriculado');
      });

    getAllSolicitudesConsultoriosBaja()
      .then(response => {
        setSolicitudesBaja(response);
      })
      .catch(err => {
        alert(
          true,
          err.getMessage() || 'No se puedieron obtener las solicitudes de baja de consultorio del matriculado',
        );
      });

    getAllSolicitudesConsultoriosRenovacion()
      .then(response => {
        setSolicitudesRenovacion(response);
      })
      .catch(err => {
        alert(
          true,
          err.getMessage() || 'No se puedieron obtener las solicitudes de renovacion de consultorio del matriculado',
        );
      });

    getAllSolicitudesConsultoriosUpdateEdilicia()
      .then(response => {
        setSolicitudesUpdateEdilicia(response);
      })
      .catch(err => {
        alert(
          true,
          err.getMessage() || 'No se puedieron obtener las solicitudes de modificación de consultorio del matriculado',
        );
      });

    getAllSolicitudesConsultoriosUpdateDirector()
      .then(response => {
        setSolicitudesUpdateDirector(response);
      })
      .catch(err => {
        alert(
          true,
          err.getMessage() || 'No se puedieron obtener las solicitudes de modificación de consultorio del matriculado',
        );
      });

    getAllSolicitudesConsultoriosUpdatePropietario()
      .then(response => {
        setSolicitudesUpdatePropietario(response);
      })
      .catch(err => {
        alert(
          true,
          err.getMessage() || 'No se puedieron obtener las solicitudes de modificación de consultorio del matriculado',
        );
      });

    getAllSolicitudesStaffMultiple()
      .then(response => {
        setSolicitudesStaffMultiple(response);
      })
      .catch(err => {
        alert(true, err.getMessage() || 'No se puedieron obtener las solicitudes de staff multiple del matriculado');
      });

    getAllSolicitudesStaff()
      .then(response => {
        setSolicitudesStaff(response);
      })
      .catch(err => {
        alert(true, err.getMessage() || 'No se puedieron obtener las solicitudes de staff del matriculado');
      });

    getAllSolicitudesStaffBaja()
      .then(response => {
        setSolicitudesStaffBaja(response);
      })
      .catch(err => {
        alert(true, err.getMessage() || 'No se puedieron obtener las solicitudes de baja de staff del matriculado');
      });
  }, []);

  return (
    <div className="content">
      <AlertModal
        isOpen={showAlert}
        message={message}
        onClose={() => alert(false)}
      />
      <Row>
        <Col md={12}>
          <Card>
            <CardHeader>
              <Row>
                <Col md={8} style={{ fontSize: '1.5rem', marginTop: '10px' }}>Mis Consultorios</Col>
              </Row>
            </CardHeader>
            <CardBody>
              <Table>
                <thead>
                  <tr>
                    <th>Nombre</th>
                    <th>Localidad</th>
                    <th>C.P.</th>
                    <th>Dirección</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    data.map(row => (
                      <tr key={ `row_${ row.idConsultorio }` }>
                        <td>{ row.nombreConsultorio ?? '' }</td>
                        <td>{ row.localidad }</td>
                        <td>{ row.codigoPostal }</td>
                        <td>{ row.direccion } { row.numero } { row.piso
                          ? `depto ${ row.piso }${ row.departamento }`
                          : ''
                        }</td>
                        <td>
                          <Link
                            to={`/consultorios/${ row.idConsultorio }/edit-horarios`}
                            className="btn btn-round btn-primary btn-sm"
                            title='Horarios Atención'
                          >
                            <i className="fa fa-clock"></i>
                          </Link>
                          { row.idConsultorioHabilitado && row.direccion !== 'ATENCIÓN DOMICILIARIA'
                            ?
                              <>
                                <Link
                                  to={`/consultorios/${ row.idConsultorioHabilitado }/view`}
                                  className="btn btn-round btn-primary btn-sm"
                                  title='Ver Consultorio'
                                >
                                  <i className="fa fa-eye"></i>
                                </Link>
                                { row.idConsultorioHabilitado == 0
                                  ?
                                    <Link
                                      to={`/consultorios/${ row.idConsultorioHabilitado }/baja`}
                                      className="btn btn-round btn-danger btn-sm"
                                      title='Baja'
                                    >
                                      <i className="fa fa-ban"></i>
                                    </Link>
                                  : null
                                }
                              </>
                            : null
                          }
                        </td>
                      </tr>
                    ))
                  }
                </tbody>
              </Table>
            </CardBody>
            <CardHeader>
              <Row>
                <Col md={12} style={{ fontSize: '1.5rem', marginTop: '10px' }}>Solicitudes de Consultorios</Col>
              </Row>
            </CardHeader>
            <CardBody>
              <Table>
                <thead>
                  <tr>
                    <th>Tipo</th>
                    <th>Nombre</th>
                    <th>C.P.</th>
                    <th>Estado</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    solicitudes.map(row => (
                      <tr key={ `consultorio_row_${ row.id }` }>
                        <td>Alta</td>
                        <td>{ row.nombre ?? '' }</td>
                        <td>{ row.codigo_postal }</td>
                        <td>{ row.state?.name }</td>
                        <td>
                          { [3, 6].includes(row.state?.id || 0)
                            ?
                              <Link
                                to={`/consultorios/${ row.id }/edit`}
                                className="btn btn-round btn-primary btn-sm"
                                title='Editar'
                              >
                                <i className="fa fa-edit"></i>
                              </Link>
                            :
                              <Link
                                to={`/consultorios/${ row.id }/edit`}
                                className="btn btn-round btn-primary btn-sm"
                                title='Ver'
                              >
                                <i className="fa fa-eye"></i>
                              </Link>
                          }
                        </td>
                      </tr>
                    ))
                  }
                  {
                    solicitudesRenovacion.map(row => (
                      <tr key={ `consultorio_row_${ row.id }` }>
                        <td>Renovación</td>
                        <td>{ row.nombre ?? '' }</td>
                        <td>{ row.codigoPostal }</td>
                        <td>{ row.state?.name }</td>
                        <td>
                          { [3].includes(row.state?.id || 0)
                            ?
                              <Link
                                to={`/consultorios/renovacion/${ row.id }/edit`}
                                className="btn btn-round btn-primary btn-sm"
                                title='Editar'
                              >
                                <i className="fa fa-edit"></i>
                              </Link>
                            :
                              <Link
                                to={`/consultorios/renovacion/${ row.id }/edit`}
                                className="btn btn-round btn-primary btn-sm"
                                title='Ver'
                              >
                                <i className="fa fa-eye"></i>
                              </Link>
                          }
                        </td>
                      </tr>
                    ))
                  }
                  {
                    solicitudesBaja.map(row => (
                      <tr key={ `consultorio_row_${ row.id }` }>
                        <td>Baja</td>
                        <td>{ row.nombre ?? '' }</td>
                        <td>{ row.codigoPostal }</td>
                        <td>{ row.state?.name }</td>
                        <td>
                          { [3].includes(row.state?.id || 0)
                            ?
                              <Link
                                to={`/consultorios/baja/${ row.id }/edit`}
                                className="btn btn-round btn-primary btn-sm"
                                title='Editar'
                              >
                                <i className="fa fa-edit"></i>
                              </Link>
                            :
                              <Link
                                to={`/consultorios/baja/${ row.id }/edit`}
                                className="btn btn-round btn-primary btn-sm"
                                title='Ver'
                              >
                                <i className="fa fa-eye"></i>
                              </Link>
                          }
                        </td>
                      </tr>
                    ))
                  }
                  {
                    solicitudesUpdateDirector.map(row => (
                      <tr key={ `consultorio_row_${ row.id }` }>
                        <td>Modificación Director</td>
                        <td>{ row.nombre ?? '' }</td>
                        <td>{ row.codigoPostal }</td>
                        <td>{ row.state?.name }</td>
                        <td>
                          { [3].includes(row.state?.id || 0)
                            ?
                              <Link
                                to={`/consultorios/update/director/${ row.id }/edit`}
                                className="btn btn-round btn-primary btn-sm"
                                title='Editar'
                              >
                                <i className="fa fa-edit"></i>
                              </Link>
                            :
                              <Link
                                to={`/consultorios/update/director/${ row.id }/edit`}
                                className="btn btn-round btn-primary btn-sm"
                                title='Ver'
                              >
                                <i className="fa fa-eye"></i>
                              </Link>
                          }
                        </td>
                      </tr>
                    ))
                  }
                  {
                    solicitudesUpdatePropietario.map(row => (
                      <tr key={ `consultorio_row_${ row.id }` }>
                        <td>Modificación Propietario</td>
                        <td>{ row.nombre ?? '' }</td>
                        <td>{ row.codigoPostal }</td>
                        <td>{ row.state?.name }</td>
                        <td>
                          { [3].includes(row.state?.id || 0)
                            ?
                              <Link
                                to={`/consultorios/update/propietario/${ row.id }/edit`}
                                className="btn btn-round btn-primary btn-sm"
                                title='Editar'
                              >
                                <i className="fa fa-edit"></i>
                              </Link>
                            :
                              <Link
                                to={`/consultorios/update/propietario/${ row.id }/edit`}
                                className="btn btn-round btn-primary btn-sm"
                                title='Ver'
                              >
                                <i className="fa fa-eye"></i>
                              </Link>
                          }
                        </td>
                      </tr>
                    ))
                  }
                  {
                    solicitudesUpdateEdilicia.map(row => (
                      <tr key={ `consultorio_row_${ row.id }` }>
                        <td>Modificación Edilicia</td>
                        <td>{ row.nombre ?? '' }</td>
                        <td>{ row.codigoPostal }</td>
                        <td>{ row.state?.name }</td>
                        <td>
                          { [3].includes(row.state?.id || 0)
                            ?
                              <Link
                                to={`/consultorios/update/edilicia/${ row.id }/edit`}
                                className="btn btn-round btn-primary btn-sm"
                                title='Editar'
                              >
                                <i className="fa fa-edit"></i>
                              </Link>
                            :
                              <Link
                                to={`/consultorios/update/edilicia/${ row.id }/edit`}
                                className="btn btn-round btn-primary btn-sm"
                                title='Ver'
                              >
                                <i className="fa fa-eye"></i>
                              </Link>
                          }
                        </td>
                      </tr>
                    ))
                  }
                </tbody>
              </Table>
            </CardBody>
            <CardHeader>
              <Row>
                <Col md={8} style={{ fontSize: '1.5rem', marginTop: '10px' }}>Solicitudes de Staff</Col>
                <Col md={4} className="text-right">
                  <Link
                    to={{ pathname: '/consultorios/staff-multiple/create' }}
                    className="btn btn-primary btn-round"
                  >
                    Mis Staffs
                  </Link>
                  <Link
                    to={{ pathname: '/consultorios/staff/create' }}
                    className="btn btn-primary btn-round"
                  >
                    Alta en Staff
                  </Link>
                  <Link
                    to={{ pathname: '/consultorios/staff-baja/create' }}
                    className="btn btn-primary btn-round"
                  >
                    Baja en Staff
                  </Link>
                </Col>
              </Row>
            </CardHeader>
            <CardBody>
              <Table>
                <thead>
                  <tr>
                    <th>Tipo</th>
                    <th>Codirector</th>
                    <th>Director Técnico</th>
                    <th>Estado</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    solicitudesStaffMultiple.map(row => (
                      <tr key={ `staff_multiple_row_${ row.id }` }>
                        <td>Mi Staff</td>
                        <td>-</td>
                        <td>{ row.matriculate_id }</td>
                        <td>{ row.state?.name }</td>
                        <td>
                          { [3].includes(row.state?.id || 0)
                            ?
                              <Link
                                to={`/consultorios/staff-multiple/${ row.id }/edit`}
                                className="btn btn-round btn-primary btn-sm"
                                title='Editar'
                              >
                                <i className="fa fa-edit"></i>
                              </Link>
                            :
                              <Link
                                to={`/consultorios/staff-multiple/${ row.id }/edit`}
                                className="btn btn-round btn-primary btn-sm"
                                title='Ver'
                              >
                                <i className="fa fa-eye"></i>
                              </Link>
                          }
                        </td>
                      </tr>
                    ))
                  }
                  {
                    solicitudesStaff.map(row => (
                      <tr key={ `staff_row_${ row.id }` }>
                        <td>Alta</td>
                        <td>{ row.es_director ? 'Sí' : 'No' }</td>
                        <td>{ row.director_tecnico }</td>
                        <td>{ row.state?.name }</td>
                        <td>
                          { [3].includes(row.state?.id || 0)
                            ?
                              <Link
                                to={`/consultorios/staff/${ row.id }/edit`}
                                className="btn btn-round btn-primary btn-sm"
                                title='Editar'
                              >
                                <i className="fa fa-edit"></i>
                              </Link>
                            :
                              <Link
                                to={`/consultorios/staff/${ row.id }/edit`}
                                className="btn btn-round btn-primary btn-sm"
                                title='Ver'
                              >
                                <i className="fa fa-eye"></i>
                              </Link>
                          }
                        </td>
                      </tr>
                    ))
                  }
                  {
                    solicitudesStaffBaja.map(row => (
                      <tr key={ `staff_row_${ row.id }` }>
                        <td>Baja</td>
                        <td>{ row.es_director ? 'Sí' : 'No' }</td>
                        <td>{ row.director_tecnico }</td>
                        <td>{ row.state?.name }</td>
                        <td>
                          { [3].includes(row.state?.id || 0)
                            ?
                              <Link
                                to={`/consultorios/staff-baja/${ row.id }/edit`}
                                className="btn btn-round btn-primary btn-sm"
                                title='Editar'
                              >
                                <i className="fa fa-edit"></i>
                              </Link>
                            :
                              <Link
                                to={`/consultorios/staff-baja/${ row.id }/edit`}
                                className="btn btn-round btn-primary btn-sm"
                                title='Ver'
                              >
                                <i className="fa fa-eye"></i>
                              </Link>
                          }
                        </td>
                      </tr>
                    ))
                  }
                </tbody>
              </Table>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
